/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_FilterInputs */

const vi_common_filter = /** @type {(inputs: Common_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lọc`)
};

/**

* @param {Common_FilterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_filter = /** @type {((inputs?: Common_FilterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_FilterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_filter(inputs)
});